import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 100,
    },
    tableWrapper: {
        overflowX: 'auto',
    }
});

const CustomTableCell = withStyles(theme => ({
    head: {
        fontSize: 14,
        textAlign: 'center'
    },
    body: {
        fontSize: 12,
        padding: 20,
        minWidth: 80
    }
}))(TableCell);

const allTimeBuckets = [
    {
        id: 1,
        name: 'Minute'
    },
    {
        id: 2,
        name: 'Hour'
    },
    {
        id: 3,
        name: 'Day'
    },
    {
        id: 4,
        name: 'Week'
    },
    {
        id: 5,
        name: 'Month'
    },
    {
        id: 6,
        name: 'Quarter'
    },
    {
        id: 7,
        name: 'Half Year'
    },
    {
        id: 8,
        name: 'Year'
    },
    {
        id: 9,
        name: 'Real Time'
    }
];

class TimeBucketsTable extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            bucketsData: [],
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.timeBuckets !== this.props.timeBuckets) {
            this.setBucketsData(nextProps.timeBuckets);
        }
    }

    setBucketsData(timeBuckets) {
        if (timeBuckets.length > 0) {
            let bucketsData = [];
            for (let groupBucket of timeBuckets) {
                let namedBucket = allTimeBuckets.find(atBucket => {
                    return groupBucket.id == atBucket.id;
                });
                bucketsData.push({
                    id: namedBucket.id,
                    name: namedBucket.name,
                    value: namedBucket.name
                });
            }

            bucketsData.sort(this.sortById);

            this.setState({
                bucketsData: bucketsData
            });
        }
    }

    sortById(a,b) {
        if (a.id < b.id)
            return -1;
        if (a.id > b.id)
            return 1;
        return 0;
    }

    render() {
        const {classes} = this.props;
        const {bucketsData} = this.state;

        return (
            <div className={classes.root}>
                <Paper>
                    <div className={classes.tableWrapper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <CustomTableCell
                                        style={{fontSize: 18}}
                                        colSpan={1}
                                        key={'buckets'}
                                        numeric={false}
                                        padding={'default'}>
                                        <b>Aggregation Time Buckets</b>
                                    </CustomTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bucketsData.map((bucket, idx) => {
                                    return (
                                        <TableRow key={idx}>
                                            <CustomTableCell style={{fontSize: 17}}>
                                                {bucket.name}
                                            </CustomTableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </div>
        );
    }
}

TimeBucketsTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TimeBucketsTable);



// WEBPACK FOOTER //
// ./src/main/content/query/tables/TimeBucketsTable.js